import { render, staticRenderFns } from "./SidebarAddNewStoreCurrency.vue?vue&type=template&id=8f5f4fd6&"
import script from "./SidebarAddNewStoreCurrency.vue?vue&type=script&lang=js&"
export * from "./SidebarAddNewStoreCurrency.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAddNewStoreCurrency.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports